/*****************/
/* INITIAL STATE */
import { TerminalCall } from "../types/TerminalCall";
import { Vessel } from "../types/Vessel";

/*****************/
const initialState = {
  container: {
    labels: [],
    types: [],
    loadingTerminals: [],
  },
  terminalCall: {
    labels: [],
  },
  terminals: {},
  containerUploadLoadingTerminals: [],
  containerUploadUnloadingTerminals: [],
  containerUploadTypes: [],
  containerLoadingTerminalCalls: [],
  containerUnloadingTerminalCalls: [],
  voyage: undefined,
  vessel: undefined,
  selectedTerminalCall: undefined,
};

/*********/
/* TYPES */
/*********/
interface FilterProperties {
  container: {
    labels?: Array<string>;
    loadingTerminals?: Array<string>;
  };
  terminalCall: {};
  containerUploadLoadingTerminals: Array<string>;
  containerUploadUnloadingTerminals: Array<string>;
  containerUploadTypes: Array<string>;
  containerLoadingTerminalCalls: Array<string>;
  containerUnloadingTerminalCalls: Array<string>;
  voyage?: string,
  vessel?: Vessel,
  selectedTerminalCall?: TerminalCall,
}

enum FilterActionTypes {
  CLEAR_FILTER = "CLEAR_FILTER",
  ADD_CONTAINER_LABEL_FILTER = "ADD_CONTAINER_LABEL_FILTER",
  REMOVE_CONTAINER_LABEL_FILTER = "REMOVE_CONTAINER_LABEL_FILTER",
  ADD_CONTAINER_TYPE_FILTER = "ADD_CONTAINER_TYPE_FILTER",
  REMOVE_CONTAINER_TYPE_FILTER = "REMOVE_CONTAINER_TYPE_FILTER",
  ADD_CONTAINER_LOADING_TERMINAL_FILTER = "ADD_CONTAINER_LOADING_TERMINAL_FILTER",
  REMOVE_CONTAINER_LOADING_TERMINAL_FILTER = "REMOVE_CONTAINER_LOADING_TERMINAL_FILTER",
  ADD_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER = "ADD_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER",
  REMOVE_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER = "REMOVE_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER",
  ADD_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER = "ADD_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER",
  REMOVE_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER = "REMOVE_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER",
  ADD_CONTAINER_UPLOAD_TYPE_FILTER = "ADD_CONTAINER_UPLOAD_TYPE_FILTER",
  REMOVE_CONTAINER_UPLOAD_TYPE_FILTER = "REMOVE_CONTAINER_UPLOAD_TYPE_FILTER",
  ADD_CONTAINER_LOADING_TERMINAL_CALL_FILTER = "ADD_CONTAINER_LOADING_TERMINAL_CALL_FILTER",
  REMOVE_CONTAINER_LOADING_TERMINAL_CALL_FILTER = "REMOVE_CONTAINER_LOADING_TERMINAL_CALL_FILTER",
  ADD_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER = "ADD_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER",
  REMOVE_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER = "REMOVE_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER",
  ADD_VOYAGE_FILTER = "ADD_VOYAGE_FILTER",
  REMOVE_VOYAGE_FILTER = "REMOVE_VOYAGE_FILTER",
  ADD_TERMINAL_CALL_LABEL_FILTER = "ADD_TERMINAL_CALL_LABEL_FILTER",
  REMOVE_TERMINAL_CALL_LABEL_FILTER = "REMOVE_TERMINAL_CALL_LABEL_FILTER",
  ADD_VESSEL_FILTER = "ADD_VESSEL_FILTER",
  REMOVE_VESSEL_FILTER = "REMOVE_VESSEL_FILTER",
  ADD_SELECTED_TERMINAL_CALL_FILTER = "ADD_SELECTED_TERMINAL_CALL_FILTER",
  REMOVE_SELECTED_TERMINAL_CALL_FILTER = "REMOVE_SELECTED_TERMINAL_CALL_FILTER",
  CLEAR_CONTAINER_LABELS_AND_TYPES = "CLEAR_CONTAINER_LABELS_AND_TYPES",
}

export interface FilterAction {
  type: FilterActionTypes;
  payload?: FilterProperties;
}

/*******************/
/* ACTION CREATORS */
/*******************/
export function clearFilter(): FilterAction {
  return {
    type: FilterActionTypes.CLEAR_FILTER,
  };
}

export function addContainerLabelFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_LABEL_FILTER,
    payload,
  };
}

export function removeContainerLabelFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_LABEL_FILTER,
    payload,
  };
}

export function addContainerLoadingTerminalFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_LOADING_TERMINAL_FILTER,
    payload,
  };
}

export function removeContainerLoadingTerminalFilterValue(
  payload
): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_LOADING_TERMINAL_FILTER,
    payload,
  };
}

export function addContainerUploadLoadingTerminalFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER,
    payload,
  };
}

export function removeContainerUploadLoadingTerminalFilterValue(
  payload
): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER,
    payload,
  };
}

export function addContainerUploadUnloadingTerminalFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER,
    payload,
  };
}

export function removeContainerUploadUnloadingTerminalFilterValue(
  payload
): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER,
    payload,
  };
}

export function addContainerUploadTypeFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_UPLOAD_TYPE_FILTER,
    payload,
  };
}

export function removeContainerUploadTypeFilterValue(
  payload
): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_UPLOAD_TYPE_FILTER,
    payload,
  };
}

export function addContainerLoadingTerminalCallFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_LOADING_TERMINAL_CALL_FILTER,
    payload,
  };
}

export function removeContainerLoadingTerminalCallFilterValue(
  payload
): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_LOADING_TERMINAL_CALL_FILTER,
    payload,
  };
}

export function addContainerUnloadingTerminalCallFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER,
    payload,
  };
}

export function removeContainerUnloadingTerminalCallFilterValue(
  payload
): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER,
    payload,
  };
}

export function addVoyageFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_VOYAGE_FILTER,
    payload,
  };
}

export function removeVoyageFilterValue(): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_VOYAGE_FILTER,
  };
}

export function addTerminalCallLabelFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_TERMINAL_CALL_LABEL_FILTER,
    payload,
  };
}

export function removeTerminalCallLabelFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_TERMINAL_CALL_LABEL_FILTER,
    payload,
  };
}

export function addVesselFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_VESSEL_FILTER,
    payload,
  };
}

export function removeVesselFilterValue(
  payload
): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_VESSEL_FILTER,
    payload,
  };
}

export function addSelectedTerminalCallFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_SELECTED_TERMINAL_CALL_FILTER,
    payload,
  };
}

export function removeSelectedTerminalCallFilterValue(): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_SELECTED_TERMINAL_CALL_FILTER,
  };
}

export function addContainerTypeFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.ADD_CONTAINER_TYPE_FILTER,
    payload,
  };
}

export function removeContainerTypeFilterValue(payload): FilterAction {
  return {
    type: FilterActionTypes.REMOVE_CONTAINER_TYPE_FILTER,
    payload,
  };
}

export function clearContainerLabelAndTypeFilters(): FilterAction {
  return {
    type: FilterActionTypes.CLEAR_CONTAINER_LABELS_AND_TYPES,
  };
}

/***********/
/* REDUCER */
/***********/
function modalReducer(state = initialState, action: FilterAction) {
  switch (action.type) {
    case FilterActionTypes.CLEAR_FILTER:
      return initialState;
    case FilterActionTypes.CLEAR_CONTAINER_LABELS_AND_TYPES:
      return {
        ...state,
        container: {
          ...state.container,
          labels: [],
          types: [],
        },
      };
    case FilterActionTypes.ADD_CONTAINER_LABEL_FILTER:
      return {
        ...state,
        container: {
          ...state.container,
          labels: [...state.container.labels, action.payload],
        },
      };
    case FilterActionTypes.REMOVE_CONTAINER_LABEL_FILTER:
      return {
        ...state,
        container: {
          ...state.container,
          labels: state.container.labels.filter(id => id !== action.payload),
        },
      };
    case FilterActionTypes.ADD_CONTAINER_TYPE_FILTER:
      return {
        ...state,
        container: {
          ...state.container,
          types: [...state.container.types, action.payload],
        },
      };
    case FilterActionTypes.REMOVE_CONTAINER_TYPE_FILTER:
      return {
        ...state,
        container: {
          ...state.container,
          types: state.container.types.filter(id => id !== action.payload),
        },
      };
    case FilterActionTypes.ADD_TERMINAL_CALL_LABEL_FILTER:
      return {
        ...state,
        terminalCall: {
          labels: [...state.terminalCall.labels, action.payload],
        },
      };
    case FilterActionTypes.REMOVE_TERMINAL_CALL_LABEL_FILTER:
      return {
        ...state,
        terminalCall: {
          labels: state.terminalCall.labels.filter(
            (element) => element !== action.payload
          ),
        },
      };
    case FilterActionTypes.ADD_CONTAINER_LOADING_TERMINAL_FILTER:
      return {
        ...state,
        container: {
          labels: [...state.container.labels],
          loadingTerminals: [
            ...state.container.loadingTerminals,
            action.payload,
          ],
        },
      };
    case FilterActionTypes.REMOVE_CONTAINER_LOADING_TERMINAL_FILTER:
      return {
        ...state,
        container: {
          labels: [...state.container.labels],
          loadingTerminals: state.container.loadingTerminals.filter(
            (element) => element !== action.payload
          ),
        },
      };
    case FilterActionTypes.ADD_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER:
      return {
        ...state,
        containerUploadLoadingTerminals: action.payload,
      };
    case FilterActionTypes.REMOVE_CONTAINER_UPLOAD_LOADING_TERMINAL_FILTER:
      return {
        ...state,
        containerUploadLoadingTerminals: state.containerUploadLoadingTerminals.length > 0 ? action.payload : [],
      };
    case FilterActionTypes.ADD_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER:
      return {
        ...state,
        containerUploadUnloadingTerminals: action.payload,
      };
    case FilterActionTypes.REMOVE_CONTAINER_UPLOAD_UNLOADING_TERMINAL_FILTER:
      return {
        ...state,
        containerUploadUnloadingTerminals: state.containerUploadLoadingTerminals.length > 0 ? action.payload : [],
      };
    case FilterActionTypes.ADD_CONTAINER_UPLOAD_TYPE_FILTER:
      return {
        ...state,
        containerUploadTypes: action.payload,
      };
    case FilterActionTypes.REMOVE_CONTAINER_UPLOAD_TYPE_FILTER:
      return {
        ...state,
        containerUploadTypes: state.containerUploadTypes.length > 0 ? action.payload : [],
      };
    case FilterActionTypes.ADD_CONTAINER_LOADING_TERMINAL_CALL_FILTER:
      return {
        ...state,
        containerLoadingTerminalCalls: action.payload,
      };
    case FilterActionTypes.REMOVE_CONTAINER_LOADING_TERMINAL_CALL_FILTER:
      return {
        ...state,
        containerLoadingTerminalCalls: state.containerLoadingTerminalCalls.length > 0 ? action.payload : [],
      };
    case FilterActionTypes.ADD_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER:
      return {
        ...state,
        containerUnloadingTerminalCalls: action.payload,
      };
    case FilterActionTypes.REMOVE_CONTAINER_UNLOADING_TERMINAL_CALL_FILTER:
      return {
        ...state,
        containerUnloadingTerminalCalls: state.containerUnloadingTerminalCalls.length > 0 ? action.payload : [],
      };
    case FilterActionTypes.ADD_VOYAGE_FILTER:
      return {
        ...state,
        voyage: action.payload,
      };
    case FilterActionTypes.REMOVE_VOYAGE_FILTER:
      return {
        ...state,
        voyage: undefined,
      };
    case FilterActionTypes.ADD_VESSEL_FILTER:
      return {
        ...state,
        vessel: action.payload,
      };
    case FilterActionTypes.REMOVE_VESSEL_FILTER:
      return {
        ...state,
        vessel: undefined,
      };
    case FilterActionTypes.ADD_SELECTED_TERMINAL_CALL_FILTER:
      return {
        ...state,
        selectedTerminalCall: action.payload,
      };
    case FilterActionTypes.REMOVE_SELECTED_TERMINAL_CALL_FILTER:
      return {
        ...state,
        selectedTerminalCall: undefined,
      };
    default:
      return state;
  }
}
export default modalReducer;
